export default {
	state: {
		segmento: {}
	},
	getters: {
		"segmento": state => state.segmento
	},
	mutations: {
		setSegmento(state, payload) {
			state.segmento = payload
		}
	},
	actions: {
		atualizarEstadoSegmento({ commit }, payload) {
			commit('setSegmento', payload)
		}
	}
};